"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MiniBagWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _MiniBag = require("../MiniBag");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const MiniBagWrapper = props => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    isOpenedMinibagOnDesktop,
    isVisible,
    handleOverlayClick,
    minibagProps,
    ownerState
  } = (0, _hooks.useMiniBag)(props);
  if (isOpenedMinibagOnDesktop) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NonModalRoot, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Fade, {
        in: isVisible,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "data-testid": getTestId('fading-wrapper'),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MiniBag.MiniBag, {
            ...minibagProps
          })
        })
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ModalRoot, {
    disableEnforceFocus: true,
    disablePortal: true,
    ownerState: ownerState,
    open: isVisible,
    slots: {
      backdrop: _mui.Backdrop
    },
    slotProps: {
      backdrop: {
        onClick: handleOverlayClick
      }
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Fade, {
      in: isVisible,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        "data-testid": getTestId('fading-wrapper'),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MiniBag.MiniBag, {
          ...minibagProps
        })
      })
    })
  });
};
exports.MiniBagWrapper = MiniBagWrapper;
